import { css } from '@emotion/react';

import IconChevronLeft from '~icons/ci/chevron-left';

import { theme } from '@adflow/frontend/ui-theme';

const sidebarToggleSize = '2rem';

const sidebarToggleStyle = css({
	color: theme.colors.palettes.primary.main,
	backgroundColor: theme.colors.background.paper,
	border: '1px solid',
	borderColor: theme.colors.input.border,
	// Make the button a circle.
	borderRadius: 9999,

	// Align with the page's headers and center on the sidebar's edge.
	zIndex: 1,
	position: 'absolute',
	transform: 'translate(-50%, -50%)',
	top: '2.25rem',
	left: 0,

	'&[aria-expanded=false]': {
		// Make the button a tab coming from the left side of the screen.
		borderTopLeftRadius: 0,
		borderBottomLeftRadius: 0,
		transform: 'translate(0, -50%)',
		left: '-0.925rem',
		transition: 'left 0.3s',
		'& > *': {
			// Move the icon so it's centered on the on-screen part of the button.
			position: 'relative',
			left: '0.3rem',
			transition: 'left 0.3s',

			// Flip the icon.
			transform: 'scaleX(-1)',
		},

		// Only apply hover styles for real hovers, not touch/hover emulation.
		'@media(hover: hover)': {
			// Slide out more on hover.
			'&:hover': {
				left: 0,
				'& > *': {
					left: '0.05rem',
				},
			},
		},
	},
});

interface SidebarToggleProps {
	sidebarCollapsed: boolean;
	setSidebarCollapsed: (collapsed: boolean) => void;
}

export function SidebarToggle({
	sidebarCollapsed,
	setSidebarCollapsed,
}: SidebarToggleProps) {
	return (
		<button
			type="button"
			onClick={() => {
				setSidebarCollapsed(!sidebarCollapsed);
			}}
			aria-expanded={!sidebarCollapsed}
			css={sidebarToggleStyle}
		>
			<IconChevronLeft width={sidebarToggleSize} height={sidebarToggleSize} />
		</button>
	);
}
